/* eslint-disable consistent-return */
/* eslint-disable lines-between-class-members */
import { observable, action } from 'mobx';
import { Utils } from 'Utils/utils';
import { makeApi, URLS } from 'Utils/apiUtil';
import * as CONSTANTS from 'Utils/constants';

class CommonAppData {
  @observable industrySectorsFullData = [];
  @observable technologiesFilterInitialData = [];

  @action
  setIndustrySectorsFullData = (value = []) => {
    this.industrySectorsFullData = value;
  };

  @action
  setTechnologiesFilterInitialData = (value = []) => {
    this.technologiesFilterInitialData = value;
  };


  getAndSetIndustryFullData = async () => {
    const response = await this.getIndustrySuggestions();

    if (response && response.data)
      this.setIndustrySectorsFullData(response.data);
  };

  getAndSetTechnologiesFilterInitialData = async () => {
    const response = await this.getTechnologiesSuggestions();

    if (response && response.data) {
      const { suggestions = [] } = response.data;
      const newList = suggestions.map(item => {
        const { id } = item;
        const newObj = {};
        newObj.pName = id;
        newObj.orgName = id;
        newObj.name = id;
        return newObj;
      });
      this.setTechnologiesFilterInitialData(newList);
    }
  };

  getTechnologiesSuggestions = async (
    queryString = '',
    cancelCallback = () => {},
  ) => {
    const config = {
      url: URLS.technologies,
      method: 'POST',
      data: {
        searchText: queryString,
        cursorMark: '',
      },
    };

    try {
      const response = await makeApi(config, false, cancelCallback);
      return response;
    } catch (error) {
      return error;
    }
  };

  getIndustrySuggestions = async (
    queryString = '',
    cancelCallback = () => {},
  ) => {
    const config = {
      url: URLS.getIndustrySectorsSuggestion,
      method: 'POST',
      data: {
        q: queryString,
      },
    };

    try {
      const response = await makeApi(config, false, cancelCallback);
      return response;
    } catch (error) {
      return error;
    }
  };

}

const commonAppData = new CommonAppData();
export { commonAppData };
export default commonAppData;
